import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import {
    DateConstants,
    DateFormat,
    forLifeOf,
    ignoreNullish,
    LifecycleAware
} from '@lsq-frontend/common-ui';
import { ApiDefaults, LsqApiServiceListSource } from '@lsq-frontend/angular-shared/api-service';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { GlobalSearchService } from '../../global-search/global-search.service';
import {
    CollectionCheck,
    GetCollectionChecksRequest,
    GetCollectionChecksResponse,
    GetCollectionChecksService
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@LifecycleAware()
@Component({
    selector: 'collections-report',
    template: `
        <div class="min-page-width-medium-up collections-report">
            <lsq-banner
                [titleText]="title"
                [subTitle]="lastUpdatedDate$ | async | lastUpdatedDate"
                [reportName]="title"
            >
            </lsq-banner>
            <div id="collections-report-page-container" class="container-fluid page-container">
                <div class="table" *ngIf="dataSource.data$ | async">
                    <collections-grouped-table
                        [dataSource]="dataSource"
                        [groupBy]="groupCollectionsBy"
                        [rowPrimaryKey]="'checkKey'"
                        [rowsAreCheckable]="false"
                        [isPaginated]="false"
                    >
                    </collections-grouped-table>
                </div>
                <h2
                    *ngIf="(totalCount$ | async) > 25"
                    class="h4 text-center font-weight-normal"
                    [style.margin]="'4rem 0'"
                >
                    Here are the top 25 matches, try refining your search for better results.
                </h2>
            </div>
        </div>

        <ng-template #checkErrorMessage let-ctx>
            This check bounced for the batch collected on
            {{ ctx.paymentDate | date: dateFormat.LsqShortYear }}
        </ng-template>
    `,
    styleUrls: ['./collections.report.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CheckNumberResultsReportComponent implements OnDestroy {
    public title = 'Collections';

    // Constants.
    public dateFormat = DateFormat;
    public groupCollectionsBy = 'paymentDate';

    public dataSource = new LsqApiServiceListSource<
        GetCollectionChecksResponse,
        GetCollectionChecksRequest,
        CollectionCheck[]
    >(this.apiService);

    public lastUpdatedDate$ = this.dataSource.data$.pipe(
        map(({ lastUpdatedDate }) => lastUpdatedDate)
    );
    public totalCount$ = this.dataSource.data$.pipe(map(({ totalCount }) => totalCount));

    constructor(
        public apiService: GetCollectionChecksService,
        private _globalSearchService: GlobalSearchService
    ) {
        this._globalSearchService.checkNumberSearch$
            .pipe(forLifeOf(this), ignoreNullish(), distinctUntilChanged())
            .subscribe((checkNumber) => {
                this.dataSource.dispatchRequest(
                    new GetCollectionChecksRequest({
                        take: ApiDefaults.TakeDefault,
                        checkNumberFilter: checkNumber,
                        // Arbitrary "forever" date range (otherwise GetCollectionChecks returns 0 rows).
                        fromDateFilter: DateConstants.BeginningOfTime,
                        toDateFilter: new Date()
                    })
                );
            });
    }

    public ngOnDestroy(): void {}
}
